module.exports = __webpack_public_path__ + "img/blockchainBorder.ec0142d8.svg";